export default {
	// Config
	apiKey: "AIzaSyB1HQGrvh9T49yRYHmJCcO7yrN_67_erwQ",
  authDomain: "nug-mytrace.firebaseapp.com",
  projectId: "nug-mytrace",
  storageBucket: "nug-mytrace.firebasestorage.app",
  messagingSenderId: "100304187064",
  appId: "1:100304187064:web:5237450f57c68075910e4d"
};
